import { useTranslation } from 'react-i18next';

import styles from './styles.module.css';

const SidebarDemoBadge = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.sidebarDemoBadge}>
      <span className={styles.sidebarDemoBadgeText}>{t('demoMode.sidebar')}</span>
    </div>
  );
};

export default SidebarDemoBadge;
